"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSimpleFee = void 0;
const feeUtils_1 = require("./feeUtils");
/**
 * Calculates total fee amount for a donation based on whether donor covers fees
 *
 * * When coverFees is true:
 *    Calculates additional amount needed on top of base donation
 *    - Example: $100 donation with 2.5% fee => $102.56 - $100 = $2.56
 *
 * * When coverFees is false:
 *    Calculates amount that will be deducted from donation
 *    - Example: $100 donation with 2.5% fee => $100 * 0.025 = $2.50
 */
const calculateSimpleFee = ({ amount, relative, fixed = 0, coverFees }) => {
    const feeParams = { amount, relative, fixed };
    const calculateCoveredFee = () => Number((0, feeUtils_1.calculateGrossAmount)(feeParams) - amount);
    const calculateUncoveredFee = () => (0, feeUtils_1.calculateFeeAmount)(feeParams);
    return coverFees ? calculateCoveredFee() : calculateUncoveredFee();
};
exports.calculateSimpleFee = calculateSimpleFee;
//# sourceMappingURL=calculateSimpleFees.js.map